export default "__VITE_ASSET__Ddw0p$lX__"